import { createFileRoute } from "@tanstack/react-router";
import { getDepartments } from "@/lib/server-functions";
import DepartmentsList from "@/pages/DepartmentsList";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { departmentsListJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/departments/")({
  loader: async () => {
    const departments = await getDepartments();
    return { departments };
  },

  head: ({ loaderData }) => {
    const pageUrl = getPageUrl("/departments");

    return {
      meta: [
        {
          title: "Medical Departments — KNMC Hospital, Kathmandu",
        },
        {
          name: "description",
          content:
            "Explore 12+ medical specialities at KNMC, a leading hospital in Kathmandu, Nepal — Cardiology, Neurology, Pediatrics, Orthopedics and more.",
        },
        {
          name: "keywords",
          content:
            "hospital departments Kathmandu, cardiology Nepal, neurology Kathmandu, pediatrics Nepal, orthopedics Kathmandu",
        },
        {
          property: "og:title",
          content: "Departments — KNMC Hospital, Kathmandu",
        },
        {
          property: "og:description",
          content:
            "Multi-speciality care in Kathmandu, Nepal — from Cardiology to Neurosurgery at KNMC.",
        },
        {
          property: "og:image",
          content: getPageUrl(ogImage),
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        departmentsListJsonLd(loaderData?.departments ?? []),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { departments } = Route.useLoaderData();
    return <DepartmentsList departments={departments} />;
  },
});